import { AnimatePresence, motion } from 'framer-motion';
import type { ReactNode } from 'react';

// Shared overlay shell: dimmed backdrop (click to close) + spring-animated
// card (click-through stopped). Callers render nothing when closed and pass
// the card body as children; cardClassName overrides the default sizing.
export default function Modal({
  onClose,
  children,
  cardClassName = 'w-full max-w-lg rounded-2xl bg-white shadow-2xl',
}: {
  onClose: () => void;
  children: ReactNode;
  cardClassName?: string;
}) {
  return (
    <AnimatePresence>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.15 }}
        className="fixed inset-0 z-50 flex items-center justify-center bg-brand-forest-900/60 px-4 backdrop-blur-sm"
        onClick={onClose}
      >
        <motion.div
          initial={{ scale: 0.92, y: 10, opacity: 0 }}
          animate={{ scale: 1, y: 0, opacity: 1 }}
          exit={{ scale: 0.95, opacity: 0 }}
          transition={{ type: 'spring', stiffness: 320, damping: 26 }}
          className={cardClassName}
          onClick={(e) => e.stopPropagation()}
        >
          {children}
        </motion.div>
      </motion.div>
    </AnimatePresence>
  );
}